import { render, staticRenderFns } from "./VFormItemDisableSwitch.vue?vue&type=template&id=733d31f6&"
import script from "./VFormItemDisableSwitch.vue?vue&type=script&lang=js&"
export * from "./VFormItemDisableSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports